import Reveal from "../../Reveal";
import SectionHeading from "../../SectionHeading";
import FooterLegal from "../../FooterLegal";
import { siteSections } from "../../../../content/siteSections";

/**
 * Shared footer and contact section.
 * Translation: Shared footer and contact section.
 *
 * @param {Object} props - Footer props.
 * @param {boolean} [props.minimal] - Render only the copyright bar, skipping the
 *   "Ready to execute?" heading and email — for pages that already have their own CTA.
 * @returns {JSX.Element} Footer section.
 */
const Footer = ({ minimal = false }) => {
  if (minimal) {
    return (
      <footer className="site-footer site-footer--minimal">
        <FooterLegal />
      </footer>
    );
  }

  return (
    <footer id="contact" className="site-footer">
      <div className="site-footer__noise" />
      <div className="site-footer__glow" />

      <div className="site-footer__inner">
        <SectionHeading
          title={siteSections.footer.title}
          description={siteSections.footer.description}
          centered
        />
        <Reveal>
          <div className="flex justify-center">
            <a
              href={`mailto:${siteSections.footer.contactEmail}`}
              className="site-footer__email"
              title="Send an email to Data Chimp Labs"
            >
              {siteSections.footer.contactEmail}
            </a>
          </div>
        </Reveal>

        <FooterLegal />
      </div>
    </footer>
  );
};

export default Footer;
